import ShipmentStatusLabel from './ShipmentStatusLabel'
export default ShipmentStatusLabel
